const messages = {
  es: {
    translations: {
      'full': 'Completo',
      'remote': 'Remoto',
      'expertise': 'Pericia',
      'days': 'dias',
      'all': 'Todos',
      'regular': 'Regular',
      'irregular': 'Irregular',
      'notifications': 'Notificaciones',
      'view all notifications': 'Ver todas las notificaciones',
      header: {
        'message': 'Bienvenido de nuevo',
        'logout': 'Cerrar sesión',
        'edit profile': 'Editar Perfil'
      },
      menu: {
        'home': 'Comienzo',
        'processes': 'Investigaciones',
        'financial control': 'Control financiero',
        'analytical report': 'Reporte analítico',
        'outher modules': 'Otros módulos',
        'settings': 'Ajustes',
        'faq': 'Preguntas frecuentes',
        'request support': 'Pedir soporte',
        'new process': 'Nueva investigacion',
        'complete your profile': 'Completa tu perfil',
        'score': 'Puntaje',
        'financial': 'financiero'
      },
      home: {
        'total processes': 'Investigaciones totales',
        'processes completed': 'Investigaciones completas',
        'processes in progress': 'Investigaciones en curso',
        'total completed': 'Total completado',
        'average execution time': 'Tiempo medio de ejecución',
        'processes': 'Investigaciones',
        'compared to (0 previous month)': 'Comparado con (0 mes pasado)',
      },
      support: {
        'need help?': '¿Necesitas ayuda?',
        'contact our support team through the contacts below': 'Póngase en contacto con nuestro equipo de soporte a través de los contactos a continuación',
        'click here': 'Haga clic aquí'
      },
      processes: {
        'search': 'Buscar',
        'export': 'Exportar',
        'selected': 'Seleccionado',
        'sinister': 'Siniestro',
        'date': 'Fecha',
        'provider': 'Proveedor',
        'well insured': 'Bien asegurado',
        'regularity': 'Regularidad',
        'in progress': 'In progress',
        'completed': 'Completa',
        'to edit': 'Para editar',
        'report': 'Reporte'
      },
      edit: {
        'process steps': 'Etapas do processo',
        'registry': 'Registro',
        'files': 'Archivos',
        'social networks': 'Redes sociales',
        'interviews': 'Entrevistas',
        'local search': 'Busqueda local',
        'public agencies': 'Organos Públicos',
        'conclused': 'Conclusión',
        'finish': 'Terminar',
        'to save': 'Guardar',
        'expenses': 'Gastos',
      }
    }
  }
}





export { messages }
